import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b2a2930")

_pushScopeId("data-v-3b2a2930")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-m-0" }
const _hoisted_3 = {
  key: 1,
  id: "spinner"
}
const _hoisted_4 = {
  id: "cards-container",
  class: "kn-page-contentp-grid p-m-0"
}
const _hoisted_5 = { class: "p-col-12" }
const _hoisted_6 = { class: "p-d-flex" }
const _hoisted_7 = { class: "kn-flex" }
const _hoisted_8 = { class: "kn-flex" }
const _hoisted_9 = { class: "p-d-flex" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "expirationDate",
  class: "kn-material-input-label"
}
const _hoisted_12 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_13 = { class: "p-d-flex p-flex-column" }
const _hoisted_14 = { class: "kn-flex" }
const _hoisted_15 = { class: "kn-flex p-mt-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.templatePruning.title')), 1)
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Card, null, {
            header: _withId(() => [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                start: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('managers.templatePruning.referenceDate')), 1)
                ]),
                _: 1
              })
            ]),
            content: _withId(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('managers.templatePruning.enterDateMessage')), 1),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", _hoisted_10, [
                      _createVNode(_component_Calendar, {
                        id: "expirationDate",
                        class: ["kn-material-input", {
                                                    'p-invalid': !_ctx.selectedDate
                                                }],
                        modelValue: _ctx.selectedDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDate = $event)),
                        showIcon: true,
                        maxDate: _ctx.maxDate,
                        manualInput: false,
                        "data-test": "date-input"
                      }, null, 8, ["modelValue", "class", "maxDate"]),
                      _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.templatePruning.selectDate')) + " * ", 1)
                    ]),
                    _createVNode(_component_Button, {
                      icon: "pi pi-filter",
                      class: "p-button-text p-button-rounded p-button-plain",
                      disabled: _ctx.filterDisabled,
                      onClick: _ctx.loadDocumentSelection,
                      "aria-label": "Filter",
                      "data-test": "filter-button"
                    }, null, 8, ["disabled", "onClick"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        (_ctx.documentSelectionVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode(_component_Card, { "data-test": "document-selection-card" }, {
                header: _withId(() => [
                  _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                    start: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('managers.templatePruning.documentSelection')), 1)
                    ]),
                    _: 1
                  })
                ]),
                content: _withId(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("p", null, _toDisplayString(_ctx.documentSelectionMessage), 1),
                      (_ctx.documentsAvailable)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "kn-button kn-button--primary",
                            disabled: _ctx.deleteDisabled,
                            onClick: _ctx.deleteConfirm,
                            "aria-label": "Delete Templates",
                            "data-test": "delete-button"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_Tree, {
                        id: "document-tree",
                        value: _ctx.nodes,
                        selectionMode: "checkbox",
                        selectionKeys: _ctx.selectedDocuments,
                        "onUpdate:selectionKeys": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDocuments = $event)),
                        filter: true,
                        filterMode: "lenient",
                        onNodeExpand: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setOpenFolderIcon($event))),
                        onNodeCollapse: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setClosedFolderIcon($event))),
                        "data-test": "document-tree"
                      }, null, 8, ["value", "selectionKeys"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})